import Api from '../../base/api.typings';
import axiosConfiguration from '../../base/axios-configuration';

class RelatorioService {
    async listarDocumentos(query: Api.App.Server.Relatorio.RelatorioDocumentoListar.Query): Promise<Api.App.Server.Relatorio.RelatorioDocumentoListar.ResultadoDto> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().get('/api/Relatorio/RelatorioDocumentoListar', { params: query }).then(e => e.data);
    }

    async listarChamados(query: Api.App.Server.Relatorio.RelatorioChamadoListar.Query): Promise<Api.App.Server.Relatorio.RelatorioChamadoListar.ResultadoDto> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().get('/api/Relatorio/RelatorioChamadoListar', { params: query }).then(e => e.data);
    }

    async listarUsuarioNovo(query: Api.App.Server.Relatorio.RelatorioUsuarioNovoListar.Query): Promise<Api.App.Server.Relatorio.RelatorioUsuarioNovoListar.ResultadoDto> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().get('/api/Relatorio/RelatorioUsuarioNovoListar', { params: query }).then(e => e.data);
    }

    async listarUsuarioServico(query: Api.App.Server.Relatorio.RelatorioUsuarioServicoListar.Query): Promise<Api.App.Server.Relatorio.RelatorioUsuarioServicoListar.ResultadoDto> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().get('/api/Relatorio/RelatorioUsuarioServicoListar', { params: query }).then(e => e.data);
    }

    async listarFaturamento(query: Api.App.Server.Relatorio.RelatorioFaturamentoListar.Query): Promise<Api.App.Server.Relatorio.RelatorioFaturamentoListar.ResultadoDto> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().get('/api/Relatorio/RelatorioFaturamentoListar', { params: query }).then(e => e.data);
    }
}

export default new RelatorioService();